export const formBuilderdebt = [
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-full',fieldLabel:'Debt Issuer Information'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Issuer Legal Description', fieldName:'issue_description', required: true},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Soverign Issuer?', fieldName:'issuer_soverign_issuer',
        possibleValues:[{value:'','label':'-'}, {value:true,'label':'Yes'}, {value:false,'label':'No'}]},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Street Address', fieldName:'issuer_street_address_1'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Street Address', fieldName:'issuer_street_address_2'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'City', fieldName:'issuer_city'},
    {type:'textinput',width:'w-1/2',fieldLabel:'State', fieldName:'issuer_state'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Postcode', fieldName:'issuer_postcode'},
    {type:'countryselect',width:'w-1/2',fieldLabel:'Country of Domicile', fieldName:'issuer_country', required: true,
        possibleValues:[{value:'CW','label':'Curacao'}, {value:'AU','label':'Australia','disabled':false}]},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Source Document', fieldName:'issuer_source_document',
        possibleValues:[
            {value:'','label':''},
            {value:'010','label':'Assignment Letter (PPN only)'},
            {value:'020','label':'Board Of Directors Resolution'},
            {value:'030','label':'Certificate'},
            {value:'040','label':'Certificate Of Amendment'},
            {value:'045','label':'Contract'},
            {value:'050','label':'Court Order'},
            {value:'060','label':'Credit Agreement'},
            {value:'070','label':'Disclosure Statement (Bankruptcy)'},
            {value:'080','label':'Exchange Offer'},
            {value:'085','label':'Extension Letter'},
            {value:'090','label':'15C2-11 (Due Diligence)'},
            {value:'100','label':'Final Offering Circular'},
            {value:'105','label':'Final Offering Memorandum'},
            {value:'120','label':'Final Prospectus'},
            {value:'110','label':'Final Private Placement Memorandum'},
            {value:'125','label':'Form Of Bond'},
            {value:'127','label':'Form Of Note'},
            {value:'129','label':'Form 8-A'},
            {value:'130','label':'Indenture'},
            {value:'140','label':'Joint Proxy/Prospectus'},
            {value:'143','label':'Lease Agreement'},
            {value:'150','label':'Loan Agreement'},
            {value:'160','label':'Minutes Of Shareholders Meeting'},
            {value:'170','label':'Notice Of Redemption'},
            {value:'180','label':'Notice To Shareholders'},
            {value:'190','label':'N-1 Registration Statement'},
            {value:'200','label':'N-1 A Registration Statement'},
            {value:'210','label':'N-2 Registration Statement'},
            {value:'215','label':'Partnership Agreement (PPN)'},
            {value:'220','label':'Plan Of Merger'},
            {value:'230','label':'Plan Of Reorganization'},
            {value:'240','label':'Preliminary Offering Circular'},
            {value:'245','label':'Preliminary Offering Memorandum'},
            {value:'260','label':'Preliminary Prospectus'},
            {value:'250','label':'Preliminary Private Placement Memorandum'},
            {value:'270','label':'Press Release'},
            {value:'280','label':'Pricing Wire'},
            {value:'290','label':'Prospectus Supplement'},
            {value:'300','label':'Proxy Statement'},
            {value:'310','label':'Purchase Agreement'},
            {value:'320','label':'S-1 Registration Statement'},
            {value:'330','label':'S-3 Registration Statement'},
            {value:'340','label':'S-4 Registration Statement'},
            {value:'350','label':'S-6 Registration Statement'},
            {value:'360','label':'SB-2 Registration Statement'},
            {value:'370','label':'Term Sheet'},
            {value:'380','label':'U-7 Disclosure Statement'},
            {value:'390','label':'Warrant Agreement'},
        ]
    },
    {type:'textinput',width:'w-1/2',fieldLabel:'Lead Underwriter', fieldName:'issuer_underwriter'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Bond Counsel', fieldName:'issuer_counsel'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Transfer Agent', fieldName:'issuer_transfer_agent'},
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-full',fieldLabel:'Issuer Contact Information'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'First Name', fieldName:'issuer_firstname'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Last Name', fieldName:'issuer_lastname'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Email Address', fieldName:'issuer_email', required:true, validate:'email'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Phone Number', fieldName:'issuer_phone', validate:'number'},
]

export const formBuilder2debt = [
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-full',fieldLabel:'Debt Issue Information'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Issue Description', fieldName:'issuer_legal_description' },
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:' '},
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:'Maturity Date (Serial Bond)'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'From' , fieldName:'issue_from'},
    {type:'textinput',width:'w-1/2',fieldLabel:'To', fieldName:'issue_to'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'interest Payment Frequency', fieldName:'issue_payment_frequency'},
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:' '},
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:'Maturity Date (Term Bond)'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Maturity Date' , fieldName:'issue_maturity_date'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Maturity Year', fieldName:'issue_maturity_year'},

    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Dated Date', fieldName:'issue_dated_date'},
    {type:'textinput',width:'w-1/2',fieldLabel:'1st Coupon Date', fieldName:'issue_1st_coupon_date'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Currency', fieldName:'issue_currency'},

    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Bond Form', fieldName:'issue_bond_form',
        possibleValues:[{value:'registered','label':'Registered'}, {value:'bearer','label':'Bearer','disabled':false}]},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Redemption Options', fieldName:'issue_redemption_options',
        possibleValues:[
            {value:'','label':'-'},
            {value:'A','label':'Amortization Plan'},
            {value:'B','label':'Amortization w/Call'},
            {value:'C','label':'Pre-Refunding'},
            {value:'E','label':'Refunding'},
            {value:'F','label':'Fixed Maturity'},
            {value:'G','label':'Fixed Maturity w/Call'},
            {value:'H','label':'Exchangeable'},
            {value:'K','label':'Fixed Maturity w/Put'},
            {value:'L','label':'Fixed Maturity w/Put/Call'},
            {value:'P','label':'Perpetual'},
            {value:'Q','label':'Perpetual w/Call'},
            {value:'R','label':'Redemption'},
        ]
    },
    {type:'selectinput',width:'w-1/2',fieldLabel:'Depository Eligible?', fieldName:'issue_depository',
        possibleValues:[{value:'','label':'-'}, {value:true,'label':'Yes'}, {value:false,'label':'No'}]},

    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Owner Restrictions', fieldName:'issue_owner_restrictions',
        possibleValues:[{value:'','label':'-'}, {value:'restricted','label':'Restricted'}, {value:'unrestricted','label':'Unrestricted'}]},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Rate Type', fieldName:'issue_rate_type',
        possibleValues:[
            {value:'','label':'-'},
            {value:'D','label':'Step Down'},
            {value:'F','label':'Fixed Rate'},
            {value:'I','label':'Increasing Rate'},
            {value:'P','label':'Payment in Kind'},
            {value:'S','label':'Split Coupon'},
            {value:'U','label':'Step Up'},
            {value:'V','label':'Variable Rate'},
            {value:'Z','label':'Zero/Discount'},
        ]
    },
    {type:'textinput',width:'w-1/2',fieldLabel:'Secondarily Insured By', fieldName:'issue_2nd_insurer'},

    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Sinking Fund', fieldName:'issue_sinking_fund',
        possibleValues:[
            {value:'','label':'-'},
            {value:'Y','label':'Yes'},
            {value:'N','label':'No'},
            {value:'Z','label':'Not Applicable'},
            {value:'X','label':'Not Available'},
        ]
    },
    {type:'selectinput',width:'w-1/2',fieldLabel:'Guarantees', fieldName:'issue_guarantees',
        possibleValues:[
            {value:'','label':'-'},
            {value:'A','label':'FCFAC'},
            {value:'B','label':'Subordinated'},
            {value:'C','label':'FFCB'},
            {value:'E','label':'SENIOR'},
            {value:'F','label':'Finan. Corp.'},
            {value:'G','label':'Guaranteed (not govt)'},
            {value:'H','label':'FHLMC'},
            {value:'J','label':'JUNIOR'},
            {value:'L','label':'FHLBA'},
            {value:'M','label':'SALLY MAE'},
            {value:'N','label':'FNMA'},
            {value:'O','label':'GINNIE MAE'},
            {value:'R','label':'RTC'},
            {value:'S','label':'Secured'},
            {value:'T','label':'Government/Tre'},
            {value:'U','label':'Unsecured'},
        ]
    },
    {type:'selectinput',width:'w-1/2',fieldLabel:'Callable', fieldName:'issue_callable',
        possibleValues:[
            {value:'','label':'-'},
            {value:'Y','label':'Yes'},
            {value:'N','label':'No'},
            {value:'Z','label':'Not Applicable'},
            {value:'X','label':'Not Available'},
        ]
    },

    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Special Instructions', fieldName:'issue_special_instructions'},
]



// WEBPACK FOOTER //
// ./src/main/content/isinApplications/debtFormFields.js